import React from "react";
import { RouteKeys, ROUTES } from "helpers/routes";
import { Language } from "interfaces/locale";
import { Navigate, useLocation } from "react-router-dom";
import useLocalizedRoutes from "hooks/useLocalizedRoutes";

const RedirectRoutes = () => {
  const { pathname, search } = useLocation();
  const { getLanguageRoute } = useLocalizedRoutes();

  const route: string = (() => {
    let languageRoute: string | undefined;

    const languages = Object.keys(ROUTES);

    for (let i = 0; i < languages.length; i += 1) {
      const language = languages[i];
      const languageRoutes = ROUTES[language as Language];

      const languageRoutesKeys = Object.keys(languageRoutes);

      for (let j = 0; j < languageRoutesKeys.length; j += 1) {
        const languageRouteKey = languageRoutesKeys[j] as RouteKeys;
        const languageRoutePath = languageRoutes[languageRouteKey];

        if (pathname === languageRoutePath) {
          return getLanguageRoute(languageRouteKey) + search;
        }
      }
    }

    return languageRoute || "/";
  })();

  return <Navigate to={route} />;
};

export default RedirectRoutes;
